import type { VoidComponent } from "solid-js";
import { createMemo, getOwner, runWithOwner } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import InputModal from "../../../components/modal/InputModal";
import type { DataSource } from "../../../types/DataSource";
import ApiService from "../../../services/ApiService";
import { dataSourcesByType } from "./dataSourcesByType";
import GenericFailureModal from "../../GenericFailureModal";
import { useModalManager } from "../../../components/modal/ModalManager";

type EditDataSourceModalProps = {
  dataSource: DataSource;
};
const EditDataSourceModal: VoidComponent<EditDataSourceModalProps> = (props) => {
  const { t } = useTranslation();
  const { replace } = useModalManager();
  const definition = createMemo(() => dataSourcesByType[props.dataSource.type]);

  return (
    <InputModal
      titleIcon="database"
      title={t(($) => $.EDIT_DATASOURCE_MODAL_TITLE, { type: definition().name })}
      variant="default"
      size="large"
      confirmLabel={t(($) => $.EDIT_DATASOURCE_MODAL_ACTIONS_ADD)}
      confirmLabelSlow={t(($) => $.EDIT_DATASOURCE_MODAL_ACTIONS_ADD_SLOW)}
      cancelLabel={t(($) => $.EDIT_DATASOURCE_MODAL_ACTIONS_CANCEL)}
      schema={definition().schema}
      initialValue={props.dataSource.configuration}
      onConfirm={(value) => {
        const owner = getOwner();
        const { toDto, onCreated } = definition();

        return new Promise((resolve, reject) => {
          ApiService.updateDataSource(props.dataSource.id).mutate(toDto(value), {
            onSuccess: (dataSource) => {
              runWithOwner(owner, () => {
                onCreated?.(dataSource, value);
              });
              resolve();
            },
            onError: (error) => {
              replace({ content: () => <GenericFailureModal error={error} /> });
              reject(error);
            },
          });
        });
      }}
    >
      {(input) => definition().EditItem({ ...input, type: "EDIT" })}
    </InputModal>
  );
};

export default EditDataSourceModal;
